import { render, staticRenderFns } from "./venue.vue?vue&type=template&id=5483a7b6&scoped=true&"
import script from "./venue.vue?vue&type=script&lang=js&"
export * from "./venue.vue?vue&type=script&lang=js&"
import style0 from "./venue.vue?vue&type=style&index=0&id=5483a7b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5483a7b6",
  null
  
)

export default component.exports